import React, { useContext, useEffect } from "react";
import { ResultContext } from "../ResultContext";
import "./LeaversInput.css";
import { Tags } from "../components/Tags";
import { GivenQuestions, LeaversType } from "../constants/Questions";
import { explanation } from "../constants/LeaverExplanation";

export function LeaversInput({
  questionId,
  titleTags,
  titleRight,
  labelExplanation,
}: {
  questionId: number;
  titleTags: string | undefined;
  titleRight: string | undefined;
  labelExplanation: string | undefined;
}) {
  const { result, setResult } = useContext(ResultContext);

  const currentQuestion = GivenQuestions.find((q) => q.id === questionId) as {
    default: string[];
    type: LeaversType;
  };

  const foundResult = (result[questionId] as {
    tags: string[];
    extra: string;
  }) || { tags: currentQuestion.default, extra: "" };

  const earlyResult = (result[10] as {
    tags: string[];
    extra: string;
  }) || { tags: currentQuestion.default, extra: "" };

  const goodResult = (result[9] as {
    tags: string[];
    extra: string;
  }) || { tags: currentQuestion.default, extra: "" };

  const defaultTags = [
    { tag: "Mental illness", supported: [LeaversType.Good, LeaversType.Early] },
    {
      tag: "Physical illness",
      supported: [LeaversType.Good, LeaversType.Early],
    },
    {
      tag: "Other",
      supported: [LeaversType.Good, LeaversType.Early, LeaversType.Bad],
    },
  ];

  if (currentQuestion.type === LeaversType.Good) {
    defaultTags.map((item, index) => {
      if (earlyResult.tags.includes(item.tag) && item.tag !== "Other") {
        delete defaultTags[index];
      }
    });
  }

  if (currentQuestion.type === LeaversType.Early) {
    defaultTags.map((item, index) => {
      if (goodResult.tags.includes(item.tag) && item.tag !== "Other") {
        delete defaultTags[index];
      }
    });
  }

  useEffect(() => {
    if (!result[questionId]) {
      const copy = { ...result };

      copy[questionId] = { tags: currentQuestion.default, extra: "" };

      setResult(copy);
    }
    // eslint-disable-next-line
  }, [questionId]);

  return (
    <>
      <Tags
        data={foundResult}
        titleTags={titleTags}
        titleRight={titleRight}
        setData={(data) => {
          const copy = { ...result };

          copy[questionId] = data;

          setResult(copy);
        }}
        options={defaultTags
          .filter((t) => t.supported.includes(currentQuestion.type))
          .map((t) => t.tag)}
        defaultOptions={currentQuestion.default}
        disableAdd={true}
        disablePopUp={true}
        disableSearch={true}
        explanation={explanation}
        labelExplanation={labelExplanation}
      />
      <div>
        <h3>Deliverable preview</h3>
        <div className="deliverable-box">
          {foundResult.tags.map((tag, index) => {
            const foundExplanation = explanation[tag];

            return (
              <div className={`${index !== 0 ? "mt-4" : ""}`}>
                <div>
                  <b>{tag}</b>
                </div>
                <div className="mt-2">
                  {foundExplanation
                    ? foundExplanation
                    : "No information available"}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
